import { render } from "./PaymentReceiptCreate.vue?vue&type=template&id=7be1c692"
import script from "./PaymentReceiptCreate.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__